import {
  GET_SENDERS_REQUEST,
  GET_SENDERS_SUCCESS,
  GET_SENDERS_FAILURE,
  POST_SENDER_REQUEST,
  POST_SENDER_SUCCESS,
  POST_SENDER_FAILURE,
  PUT_SENDER_REQUEST,
  PUT_SENDER_SUCCESS,
  PUT_SENDER_FAILURE,
  DELETE_SENDER_REQUEST,
  DELETE_SENDER_SUCCESS,
  DELETE_SENDER_FAILURE,
  GET_USERS_ME_REQUEST,
  GET_USERS_ME_SUCCESS,
  GET_USERS_ME_FAILURE,
  DELETE_USERS_ME_REQUEST,
  DELETE_USERS_ME_SUCCESS,
  DELETE_USERS_ME_FAILURE,
  PATCH_USERS_ME_REQUEST,
  PATCH_USERS_ME_SUCCESS,
  PATCH_USERS_ME_FAILURE,
  PUT_USERS_ME_PAYMENT_REQUEST,
  PUT_USERS_ME_PAYMENT_SUCCESS,
  PUT_USERS_ME_PAYMENT_FAILURE,
  POST_USERS_ME_PAYMENT_REQUEST,
  POST_USERS_ME_PAYMENT_SUCCESS,
  POST_USERS_ME_PAYMENT_FAILURE,
  POST_USERS_ME_PLANS_REQUEST,
  POST_USERS_ME_PLANS_SUCCESS,
  POST_USERS_ME_PLANS_FAILURE,
  POST_USERS_PAYMENTS_AND_PLANS_REQUEST,
  POST_USERS_PAYMENTS_AND_PLANS_SUCCESS,
  POST_USERS_PAYMENTS_AND_PLANS_FAILURE,
  REMOVE_CRM,
  SET_SHOW_DEMO_DATA,
  GET_ORDER_CONTACTS_REQUEST,
  GET_ORDER_CONTACTS_SUCCESS,
  GET_ORDER_CONTACTS_FAILURE,
  POST_ORDER_CONTACTS_REQUEST,
  POST_ORDER_CONTACTS_SUCCESS,
  POST_ORDER_CONTACTS_FAILURE,
  DELETE_ORDER_CONTACTS_REQUEST,
  DELETE_ORDER_CONTACTS_SUCCESS,
  DELETE_ORDER_CONTACTS_FAILURE,
  GET_USER_MAILS_REQUEST,
  GET_USER_MAILS_SUCCESS,
  GET_USER_MAILS_FAILURE,
  POST_USER_MAILS_REQUEST,
  POST_USER_MAILS_SUCCESS,
  POST_USER_MAILS_FAILURE,
  DELETE_USER_MAILS_BY_ID_REQUEST,
  DELETE_USER_MAILS_BY_ID_SUCCESS,
  DELETE_USER_MAILS_BY_ID_FAILURE,
  PUT_USER_MAILS_REQUEST,
  PUT_USER_MAILS_SUCCESS,
  PUT_USER_MAILS_FAILURE,
  PATCH_USERS_EMAIL_NOTIFICATION_FLAG_REQUEST,
  PATCH_USERS_EMAIL_NOTIFICATION_FLAG_SUCCESS,
  PATCH_USERS_EMAIL_NOTIFICATION_FLAG_FAILURE,
  GET_CHILD_USERS_REQUEST,
  GET_CHILD_USERS_SUCCESS,
  GET_CHILD_USERS_FAILURE,
  POST_CHILD_USER_REQUEST,
  POST_CHILD_USER_SUCCESS,
  POST_CHILD_USER_FAILURE,
  GET_CHILD_USER_BY_ID_REQUEST,
  GET_CHILD_USER_BY_ID_SUCCESS,
  GET_CHILD_USER_BY_ID_FAILURE,
  PUT_CHILD_USERS_AUTHORITY_REQUEST,
  PUT_CHILD_USERS_AUTHORITY_SUCCESS,
  PUT_CHILD_USERS_AUTHORITY_FAILURE,
  PATCH_CHILD_USER_AUTHORITY_BY_ID_REQUEST,
  PATCH_CHILD_USER_AUTHORITY_BY_ID_SUCCESS,
  PATCH_CHILD_USER_AUTHORITY_BY_ID_FAILURE,
  DELETE_CHILD_USERS_REQUEST,
  DELETE_CHILD_USERS_SUCCESS,
  DELETE_CHILD_USERS_FAILURE,
  GET_PROXY_LOGIN_CHILD_USER_REQUEST,
  GET_PROXY_LOGIN_CHILD_USER_SUCCESS,
  GET_PROXY_LOGIN_CHILD_USER_FAILURE,
  GET_PROXY_LOGIN_PARENT_USER_REQUEST,
  GET_PROXY_LOGIN_PARENT_USER_SUCCESS,
  GET_PROXY_LOGIN_PARENT_USER_FAILURE,
} from "../../constants/ActionTypes";
import { SendersApi } from "../api/SendersApi";
import { UsersApi } from "../api/UsersApi";
import { runSessionSwitch } from "../api/ApiClient";
import { OrderContactApi } from "../api/OrderContactApi";
import { UserMailsApi } from "../api/UserMailsApi";
import { loginRedirect } from "./Signin";
import { push, replace } from "react-router-redux";
import { PaymentType } from "../../constants/ComponentTypes";

/*********** POST /senders: 送り主を登録 **********/

const postSenderRequest = () => ({
  type: POST_SENDER_REQUEST,
});

const postSenderSuccess = (sender) => ({
  type: POST_SENDER_SUCCESS,
  payload: {
    sender: sender,
  },
});

const postSenderFailure = (error) => ({
  type: POST_SENDER_FAILURE,
  payload: {
    error: error,
  },
});

export const postSender = (data) => {
  return (dispatch) => {
    dispatch(postSenderRequest());

    SendersApi.postSender(data, dispatch)
      .then((response) => {
        dispatch(postSenderSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(postSenderFailure(error.response));
      });
  };
};

/*********** PUT /senders: 指定したIDのsendersを更新する **********/

const putSenderRequest = () => ({
  type: PUT_SENDER_REQUEST,
});

const putSenderSuccess = (sender) => ({
  type: PUT_SENDER_SUCCESS,
  payload: {
    sender: sender,
  },
});

const putSenderFailure = (error) => ({
  type: PUT_SENDER_FAILURE,
  payload: {
    error: error,
  },
});

export const putSender = (sender) => {
  return (dispatch) => {
    dispatch(putSenderRequest());

    const { layout_type, ...rest } = sender;

    let data = {
      layout_type: parseInt(layout_type, 10),
      ...rest,
    };

    SendersApi.putSender(data, dispatch)
      .then((response) => {
        dispatch(putSenderSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(putSenderFailure(error.response));
      });
  };
};

/*********** GET /senders: sendersデータ全てを取得する **********/

const getSendersRequest = () => ({
  type: GET_SENDERS_REQUEST,
});

const getSendersSuccess = (senders) => ({
  type: GET_SENDERS_SUCCESS,
  payload: {
    senders: senders,
  },
});

const getSendersFailure = (error) => ({
  type: GET_SENDERS_FAILURE,
  payload: {
    error: error,
  },
});

export const getSenders = () => {
  return (dispatch) => {
    dispatch(getSendersRequest());

    SendersApi.getSenders(dispatch)
      .then((response) => {
        dispatch(getSendersSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getSendersFailure(error.response));
      });
  };
};

/*********** DELETE /senders: 指定したIDのsendersを削除する **********/
const deleteSenderRequest = () => ({
  type: DELETE_SENDER_REQUEST,
});

const deleteSenderSuccess = (id) => ({
  type: DELETE_SENDER_SUCCESS,
  payload: {
    senderId: id,
  },
});

const deleteSenderFailure = (error) => ({
  type: DELETE_SENDER_FAILURE,
  payload: {
    error: error,
  },
});

export const deleteSender = (id) => {
  return (dispatch) => {
    dispatch(deleteSenderRequest());

    SendersApi.deleteSender(id, dispatch)
      .then(() => {
        dispatch(deleteSenderSuccess(id));
      })
      .catch((error) => {
        dispatch(deleteSenderFailure(error.response));
      });
  };
};

/*********** GET /users/me: ログイン中のユーザのusersを取得する **********/

export const getUserRequest = () => ({
  type: GET_USERS_ME_REQUEST,
});

export const getUserSuccess = (user) => ({
  type: GET_USERS_ME_SUCCESS,
  payload: {
    user: user,
  },
});

export const getUserFailure = (error) => ({
  type: GET_USERS_ME_FAILURE,
  payload: {
    error: error,
  },
});

const setShowDemoData = (user, overview) => ({
  type: SET_SHOW_DEMO_DATA,
  payload: {
    user: user,
    overview: overview,
  },
});

export const getUser = () => {
  return (dispatch, getState) => {
    dispatch(getUserRequest());

    UsersApi.getUser(dispatch)
      .then((response) => {
        let currentPath = getState().router.location.pathname;

        if (
          !currentPath.includes("/reset-password") &&
          !currentPath.includes("/update-security-question")
        ) {
          loginRedirect(response.data.data, dispatch);
        }

        dispatch(setShowDemoData(response.data.data));
        dispatch(getUserSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getUserFailure(error.response));
      });
  };
};

/*********** DELETE /users/me: ログイン中のusersを削除しログアウトする **********/

const deleteUserRequest = () => ({
  type: DELETE_USERS_ME_REQUEST,
});

const deleteUserSuccess = () => ({
  type: DELETE_USERS_ME_SUCCESS,
});

const deleteUserFailure = (error) => ({
  type: DELETE_USERS_ME_FAILURE,
  payload: {
    error: error,
  },
});

export const deleteUser = () => {
  return (dispatch) => {
    dispatch(deleteUserRequest());

    UsersApi.deleteUser(dispatch)
      .then(() => {
        localStorage.removeItem("user");
        dispatch(push(`/thank-you`));
        dispatch(deleteUserSuccess());
      })
      .catch((error) => {
        dispatch(deleteUserFailure(error.response));
      });
  };
};

/*********** PATCH /users/me: ログイン中のusersを更新する **********/
const patchUserRequest = (user) => ({
  type: PATCH_USERS_ME_REQUEST,
  payload: {
    user: user,
  },
});

const patchUserSuccess = (user) => ({
  type: PATCH_USERS_ME_SUCCESS,
  payload: {
    user: user,
  },
});

const patchUserFailure = (error) => ({
  type: PATCH_USERS_ME_FAILURE,
  payload: {
    error: error,
  },
});

export const patchUser = (user) => {
  return (dispatch) => {
    dispatch(patchUserRequest(user));

    UsersApi.patchUser(user, dispatch)
      .then((response) => {
        dispatch(patchUserSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(patchUserFailure(error.response));
      });
  };
};

/*********** PATCH /users/me: メール通知設定をON/OFFにする **********/
const patchUsersEmailNotificationFlagRequest = (email_notification_flag) => ({
  type: PATCH_USERS_EMAIL_NOTIFICATION_FLAG_REQUEST,
  payload: {
    email_notification_flag: email_notification_flag,
  },
});

const patchUsersEmailNotificationFlagSuccess = (user) => ({
  type: PATCH_USERS_EMAIL_NOTIFICATION_FLAG_SUCCESS,
  payload: {
    user: user,
  },
});

const patchUsersEmailNotificationFlagFailure = (error) => ({
  type: PATCH_USERS_EMAIL_NOTIFICATION_FLAG_FAILURE,
  payload: {
    error: error,
  },
});

export function patchUsersEmailNotificationFlag(data) {
  return async (dispatch) => {
    dispatch(
      patchUsersEmailNotificationFlagRequest(data.email_notification_flag)
    );

    UsersApi.patchUser(data, dispatch)
      .then((response) => {
        dispatch(patchUsersEmailNotificationFlagSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(patchUsersEmailNotificationFlagFailure(error.response));
      });
  };
}

/*********** PUT /users/me: ログイン中のusers paymentを更新する **********/

const putUsersMePaymentRequest = () => ({
  type: PUT_USERS_ME_PAYMENT_REQUEST,
});

const putUsersMePaymentSuccess = (user_payment) => ({
  type: PUT_USERS_ME_PAYMENT_SUCCESS,
  payload: {
    user_payment: user_payment,
  },
});

const putUsersMePaymentFailure = (error) => ({
  type: PUT_USERS_ME_PAYMENT_FAILURE,
  payload: {
    error: error,
  },
});

export const putUsersMePayment = (info) => {
  return (dispatch, getState) => {
    dispatch(putUsersMePaymentRequest());

    let paymentInfo = getState().accountSetting.user.user_payment;

    let data = {
      //お支払い情報がない時は、デフォルトとして請求書払いと扱います
      payment_method: paymentInfo
        ? paymentInfo.payment_method
        : PaymentType.INVOICE,
    };

    for (let key in info) {
      data["bill_" + key] = info[key];
    }

    UsersApi.putUsersMePayment(data, dispatch)
      .then((response) => {
        dispatch(putUsersMePaymentSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(putUsersMePaymentFailure(error.response));
      });
  };
};

/*********** POST /users/me: ログイン中のusers paymentを更新する **********/

const postUsersMePaymentRequest = () => ({
  type: POST_USERS_ME_PAYMENT_REQUEST,
});

const postUsersMePaymentSuccess = (user_payment) => ({
  type: POST_USERS_ME_PAYMENT_SUCCESS,
  payload: {
    user_payment: user_payment,
  },
});

const postUsersMePaymentFailure = (error) => ({
  type: POST_USERS_ME_PAYMENT_FAILURE,
  payload: {
    error: error,
  },
});

export const postUsersMePayment = (info) => {
  return (dispatch, getState) => {
    dispatch(postUsersMePaymentRequest());

    let paymentInfo = getState().accountSetting.user.user_payment;

    let data = {
      //お支払い情報がない時は、デフォルトとして請求書払いと扱います
      payment_method: paymentInfo
        ? paymentInfo.payment_method
        : PaymentType.INVOICE,
    };

    for (let key in info) {
      data["bill_" + key] = info[key];
    }

    UsersApi.postUsersMePayment(data, dispatch)
      .then((response) => {
        dispatch(postUsersMePaymentSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(postUsersMePaymentFailure(error.response));
      });
  };
};

/*** POST /users/me/plans ***/
const postUsersMePlansRequest = () => ({
  type: POST_USERS_ME_PLANS_REQUEST,
});

const postUsersMePlansSuccess = (data) => ({
  type: POST_USERS_ME_PLANS_SUCCESS,
  payload: {
    data: data,
  },
});

const postUsersMePlansFailure = (error) => ({
  type: POST_USERS_ME_PLANS_FAILURE,
  payload: {
    error: error,
  },
});

export function postUsersMePlans(data) {
  return async (dispatch) => {
    dispatch(postUsersMePlansRequest());

    UsersApi.postUsersMePlans(data, dispatch)
      .then((response) => {
        dispatch(postUsersMePlansSuccess(response.data.data));
        dispatch(getUser());
      })
      .catch((error) => {
        dispatch(postUsersMePlansFailure(error.response));
      });
  };
}

/*** POST /users/me/plans and POST /users/me/payments ***/
const postUsersPaymentsAndPlansRequest = () => ({
  type: POST_USERS_PAYMENTS_AND_PLANS_REQUEST,
});

const postUsersPaymentsAndPlansSuccess = () => ({
  type: POST_USERS_PAYMENTS_AND_PLANS_SUCCESS,
});

const postUsersPaymentsAndPlansFailure = (error) => ({
  type: POST_USERS_PAYMENTS_AND_PLANS_FAILURE,
  payload: {
    error: error,
  },
});

export function postPaymentAndPlans(paymentData, planData) {
  return async (dispatch, getState) => {
    dispatch(postUsersPaymentsAndPlansRequest());

    let paymentInfo = getState().accountSetting.user.user_payment;

    let data = {
      //お支払い情報がない時は、デフォルトとして請求書払いと扱います
      payment_method: paymentInfo
        ? paymentInfo.payment_method
        : PaymentType.INVOICE,
    };

    for (let key in paymentData) {
      data["bill_" + key] = paymentData[key];
    }

    UsersApi.postUsersMePayment(data, dispatch)
      .then(() => {
        UsersApi.postUsersMePlans(planData, dispatch)
          .then(() => {
            dispatch(getUser());
            dispatch(postUsersPaymentsAndPlansSuccess());
          })
          .catch((error) => {
            dispatch(postUsersPaymentsAndPlansFailure(error.response));
          });
      })
      .catch((error) => {
        dispatch(postUsersPaymentsAndPlansFailure(error.response));
      });
  };
}

export const removeCrm = (id) => ({
  type: REMOVE_CRM,
  payload: {
    id: id,
  },
});

/*** GET /order_contacts ***/
const getOrderContactsRequest = () => ({
  type: GET_ORDER_CONTACTS_REQUEST,
});

const getOrderContactsSuccess = (orderContacts) => ({
  type: GET_ORDER_CONTACTS_SUCCESS,
  payload: {
    orderContacts: orderContacts,
  },
});

const getOrderContactsFailure = (error) => ({
  type: GET_ORDER_CONTACTS_FAILURE,
  payload: {
    error: error,
  },
});

export function getOrderContacts() {
  return async (dispatch) => {
    dispatch(getOrderContactsRequest());

    OrderContactApi.getOrderContacts(dispatch)
      .then((response) => {
        dispatch(getOrderContactsSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getOrderContactsFailure(error.response));
      });
  };
}

/*** POST /order_contacts ***/
const postOrderContactsRequest = () => ({
  type: POST_ORDER_CONTACTS_REQUEST,
});

const postOrderContactsSuccess = (orderContact) => ({
  type: POST_ORDER_CONTACTS_SUCCESS,
  payload: {
    orderContact: orderContact,
  },
});

const postOrderContactsFailure = (error) => ({
  type: POST_ORDER_CONTACTS_FAILURE,
  payload: {
    error: error,
  },
});

export function postOrderContacts(data) {
  return async (dispatch) => {
    dispatch(postOrderContactsRequest());

    OrderContactApi.postOrderContacts(data, dispatch)
      .then((response) => {
        dispatch(postOrderContactsSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(postOrderContactsFailure(error.response));
      });
  };
}

/*** DELETE /order_contacts ***/
const deleteOrderContactsRequest = () => ({
  type: DELETE_ORDER_CONTACTS_REQUEST,
});

const deleteOrderContactsSuccess = (id) => ({
  type: DELETE_ORDER_CONTACTS_SUCCESS,
  payload: {
    id: id,
  },
});

const deleteOrderContactsFailure = (error) => ({
  type: DELETE_ORDER_CONTACTS_FAILURE,
  payload: {
    error: error,
  },
});

export function deleteOrderContacts(id) {
  return async (dispatch) => {
    dispatch(deleteOrderContactsRequest());

    OrderContactApi.deleteOrderContacts(id, dispatch)
      .then(() => {
        dispatch(deleteOrderContactsSuccess(id));
      })
      .catch((error) => {
        dispatch(deleteOrderContactsFailure(error.response));
      });
  };
}

/*** GET /user_mails ***/
const getUserMailsRequest = () => ({
  type: GET_USER_MAILS_REQUEST,
});

const getUserMailsSuccess = (mails) => ({
  type: GET_USER_MAILS_SUCCESS,
  payload: { mails: mails },
});

const getUserMailsFailure = (error) => ({
  type: GET_USER_MAILS_FAILURE,
  payload: {
    error: error,
  },
});

export function getUserMails(data) {
  return async (dispatch) => {
    dispatch(getUserMailsRequest());

    UserMailsApi.getUserMails(data, dispatch)
      .then((response) => {
        dispatch(getUserMailsSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getUserMailsFailure(error.response));
      });
  };
}

/*** POST /user_mails ***/
const postUserMailsRequest = () => ({
  type: POST_USER_MAILS_REQUEST,
});

const postUserMailsSuccess = (mail) => ({
  type: POST_USER_MAILS_SUCCESS,
  payload: { mail: mail },
});

const postUserMailsFailure = (error) => ({
  type: POST_USER_MAILS_FAILURE,
  payload: {
    error: error,
  },
});

export function postUserMails(data) {
  return async (dispatch) => {
    dispatch(postUserMailsRequest());

    UserMailsApi.postUserMails(data, dispatch)
      .then((response) => {
        dispatch(postUserMailsSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(postUserMailsFailure(error.response));
      });
  };
}

/*** DELETE /user_mails/{id} ***/
const deleteUserMailsByIdRequest = () => ({
  type: DELETE_USER_MAILS_BY_ID_REQUEST,
});

const deleteUserMailsByIdSuccess = (id) => ({
  type: DELETE_USER_MAILS_BY_ID_SUCCESS,
  payload: { userMailId: id },
});

const deleteUserMailsByIdFailure = (error) => ({
  type: DELETE_USER_MAILS_BY_ID_FAILURE,
  payload: {
    error: error,
  },
});

export function deleteUserMailsById(id) {
  return async (dispatch) => {
    dispatch(deleteUserMailsByIdRequest());

    UserMailsApi.deleteUserMailsById(id, dispatch)
      .then(() => {
        dispatch(deleteUserMailsByIdSuccess(id));
      })
      .catch((error) => {
        dispatch(deleteUserMailsByIdFailure(error.response));
      });
  };
}

/*** PUT /user_mails ***/
const putUserMailsRequest = () => ({
  type: PUT_USER_MAILS_REQUEST,
});

const putUserMailsSuccess = (mail) => ({
  type: PUT_USER_MAILS_SUCCESS,
  payload: { mail: mail },
});

const putUserMailsFailure = (error) => ({
  type: PUT_USER_MAILS_FAILURE,
  payload: {
    error: error,
  },
});

export function putUserMails(id, data) {
  return async (dispatch) => {
    dispatch(putUserMailsRequest());

    UserMailsApi.putUserMails(id, data, dispatch)
      .then((response) => {
        dispatch(putUserMailsSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(putUserMailsFailure(error.response));
      });
  };
}

/*** GET /users/child-accounts ログイン中のユーザの子アカウント一覧を取得する ***/
export const getChildUsersRequest = (data) => ({
  type: GET_CHILD_USERS_REQUEST,
  payload: {
    sort_type: data ? data["sort_type"] : 'id',
    sort_order: data ? data["sort_order"] : 'desc',
  }
});

export const getChildUsersSuccess = (childUsers) => ({
  type: GET_CHILD_USERS_SUCCESS,
  payload: {
    childUsers: childUsers,
  },
});

export const getChildUsersFailure = (error) => ({
  type: GET_CHILD_USERS_FAILURE,
  payload: {
    error: error,
  },
});

export const getChildUsers = (data) => {
  return (dispatch) => {
    dispatch(getChildUsersRequest(data));

    UsersApi.getChildUsers(data, dispatch)
      .then((response) => {
        dispatch(getChildUsersSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getChildUsersFailure(error.response));
      });
  };
};

/*** GET /users/child-accounts/{:id} ログイン中のユーザの指定された子アカウントを取得する ***/
export const getChildUserByIdRequest = () => ({
  type: GET_CHILD_USER_BY_ID_REQUEST,
});

export const getChildUserByIdSuccess = (childUser) => ({
  type: GET_CHILD_USER_BY_ID_SUCCESS,
  payload: {
    childUser: childUser,
  },
});

export const getChildUserByIdFailure = (error) => ({
  type: GET_CHILD_USER_BY_ID_FAILURE,
  payload: {
    error: error,
  },
});

export const getChildUserById = (id) => {
  return (dispatch) => {
    dispatch(getChildUserByIdRequest());

    UsersApi.getChildUserById(id, dispatch)
      .then((response) => {
        dispatch(getChildUserByIdSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getChildUserByIdFailure(error.response));
      });
  };
};

/*** POST /users/child-accounts ログイン中のユーザの子アカウントを作成する ***/
const postChildUserRequest = () => ({
  type: POST_CHILD_USER_REQUEST,
});

const postChildUserSuccess = (childUsers) => ({
  type: POST_CHILD_USER_SUCCESS,
  payload: { childUsers: childUsers },
});

const postChildUserFailure = (error) => ({
  type: POST_CHILD_USER_FAILURE,
  payload: {
    error: error,
  },
});

export function postChildUser(data) {
  return async (dispatch) => {
    dispatch(postChildUserRequest());

    UsersApi.postChildUser(data, dispatch)
      .then((response) => {
        dispatch(postChildUserSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(postChildUserFailure(error.response));
      });
  };
}

/*** PUT /users/child-accounts/authority ログイン中のユーザの子アカウントの権限変更 ***/
const putChildUsersAuthorityRequest = () => ({
  type: PUT_CHILD_USERS_AUTHORITY_REQUEST,
});

const putChildUsersAuthoritySuccess = (childUsers) => ({
  type: PUT_CHILD_USERS_AUTHORITY_SUCCESS,
  payload: { childUsers: childUsers },
});

const putChildUsersAuthorityFailure = (error) => ({
  type: PUT_CHILD_USERS_AUTHORITY_FAILURE,
  payload: {
    error: error,
  },
});

export function putChildUsersAuthority(data) {
  return async (dispatch) => {
    dispatch(putChildUsersAuthorityRequest());

    UsersApi.putChildUsersAuthority(data, dispatch)
      .then((response) => {
        dispatch(putChildUsersAuthoritySuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(putChildUsersAuthorityFailure(error.response));
      });
  };
}

/*** PATCH /users/child-accounts/{id} ログイン中のユーザの子アカウント情報を更新する ***/
const patchChildUserAuthorityByIdRequest = () => ({
  type: PATCH_CHILD_USER_AUTHORITY_BY_ID_REQUEST,
});

const patchChildUserAuthorityByIdSuccess = (childUser) => ({
  type: PATCH_CHILD_USER_AUTHORITY_BY_ID_SUCCESS,
  payload: {
    childUser: childUser,
  },
});

const patchChildUserAuthorityByIdFailure = (error) => ({
  type: PATCH_CHILD_USER_AUTHORITY_BY_ID_FAILURE,
  payload: {
    error: error,
  },
});

export const patchChildUserAuthorityById = (id, data) => {
  return (dispatch) => {
    dispatch(patchChildUserAuthorityByIdRequest());

    UsersApi.patchChildUserAuthorityById(id, data, dispatch)
      .then((response) => {
        dispatch(patchChildUserAuthorityByIdSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(patchChildUserAuthorityByIdFailure(error.response));
      });
  };
};

/*** DELETE /users/child-accounts/{id} ログイン中のユーザの子アカウントを削除する ***/
const deleteChildUserRequest = () => ({
  type: DELETE_CHILD_USERS_REQUEST,
});

const deleteChildUserSuccess = () => ({
  type: DELETE_CHILD_USERS_SUCCESS,
});

const deleteChildUserFailure = (error) => ({
  type: DELETE_CHILD_USERS_FAILURE,
  payload: {
    error: error,
  },
});

export const deleteChildUser = (id, data) => {
  return (dispatch) => {
    dispatch(deleteChildUserRequest());

    UsersApi.deleteChildUser(id, data, dispatch)
      .then(() => {
        dispatch(push(`/setting/child-accounts`));
        dispatch(deleteChildUserSuccess());
      })
      .catch((error) => {
        dispatch(deleteChildUserFailure(error.response));
      });
  };
};

/*** GET /users/child-accounts/proxy_login/{id} 子アカウントに代理ログインを行う ***/
export const getProxyLoginChildUserRequest = (id) => ({
  type: GET_PROXY_LOGIN_CHILD_USER_REQUEST,
  payload: {
    id: id,
  }
});

export const getProxyLoginChildUserSuccess = (user) => ({
  type: GET_PROXY_LOGIN_CHILD_USER_SUCCESS,
  payload: {
    user: user,
  },
});

export const getProxyLoginChildUserFailure = (error) => ({
  type: GET_PROXY_LOGIN_CHILD_USER_FAILURE,
  payload: {
    error: error,
  },
});

export const getProxyLoginChildUser = (id) => {
  return (dispatch) => {
    dispatch(replace(`/loading`));
    dispatch(getProxyLoginChildUserRequest(id));

    // 旧セッションのCookieのまま他のリクエストが通信して、サインイン画面に飛ばされるのを防ぐ
    // TODO バックエンドのUserResourceクラスが重いので改善した方がよい。
    runSessionSwitch(() => UsersApi.getProxyLoginChildUser(id, dispatch))
      .then((response) => {
        localStorage.setItem('user', JSON.stringify({ email: response.data.data.email, loginTime: new Date() }));
        dispatch(getProxyLoginChildUserSuccess(response));
        // TODO バックエンドからのダミーデータを取得ではなく、フロントのみでダミーデータ表示する処理ができそう。フロントのみで処理ができれば、UserResourceクラスのレスポンスが重い問題を改善できる
        dispatch(setShowDemoData(response.data.data));
        dispatch(push(`/order-dashboard`));
      })
      .catch((error) => {
        dispatch(getProxyLoginChildUserFailure(error));
      });
  };
};

/*** GET /users/parent-account/proxy_login 親アカウントに代理ログインを行う ***/
export const getProxyLoginParentUserRequest = () => ({
  type: GET_PROXY_LOGIN_PARENT_USER_REQUEST,
});

export const getProxyLoginParentUserSuccess = (user) => ({
  type: GET_PROXY_LOGIN_PARENT_USER_SUCCESS,
  payload: {
    user: user,
  },
});

export const getProxyLoginParentUserFailure = (error) => ({
  type: GET_PROXY_LOGIN_PARENT_USER_FAILURE,
  payload: {
    error: error,
  },
});

export const getProxyLoginParentUser = () => {
  return (dispatch) => {
    dispatch(replace(`/loading`));
    dispatch(getProxyLoginParentUserRequest());

    // 旧セッションのCookieのまま他のリクエストが通信して、サインイン画面に飛ばされるのを防ぐ
    // TODO バックエンドのUserResourceクラスが重いので改善した方がよい。
    runSessionSwitch(() => UsersApi.getProxyLoginParentUser(dispatch))
      .then((response) => {
        localStorage.setItem('user', JSON.stringify({ email: response.data.data.email, loginTime: new Date() }));
        dispatch(getProxyLoginParentUserSuccess(response));
        // TODO バックエンドからのダミーデータを取得ではなく、フロントのみでダミーデータ表示する処理ができそう。フロントのみで処理ができれば、UserResourceクラスのレスポンスが重い問題を改善できる
        dispatch(setShowDemoData(response.data.data));
        dispatch(push(`/order-dashboard`));
      })
      .catch((error) => {
        dispatch(getProxyLoginParentUserFailure(error));
      });
  };
};


// WEBPACK FOOTER //
// ./src/redux/actions/AccountSetting.js